module.exports = __webpack_public_path__ + "img/module-bg.cd968564.jpg";